"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = require("@/api/product");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DebtRatioConfig',
  data: function data() {
    return {
      loading: false,
      submitLoading: false,
      tableData: [],
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      editId: null,
      form: {
        debtRatioPercent: null,
        markupParam: null
      },
      rules: {
        debtRatioPercent: [{
          required: true,
          message: '请输入债权额百分比',
          trigger: 'blur'
        }],
        markupParam: [{
          required: true,
          message: '请输入上浮参数',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      (0, _product.debtRatioListApi)().then(function (res) {
        _this.tableData = res || [];
      }).catch(function (e) {
        _this.$message.error(e.message || '加载失败');
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleAdd: function handleAdd() {
      this.dialogTitle = '新增债权档位';
      this.isEdit = false;
      this.editId = null;
      this.form.debtRatioPercent = null;
      this.form.markupParam = null;
      this.dialogVisible = true;
    },
    handleEdit: function handleEdit(row) {
      this.dialogTitle = '编辑债权档位';
      this.isEdit = true;
      this.editId = row.id;
      this.form.debtRatioPercent = Number((row.debtRatio * 100).toFixed(0));
      this.form.markupParam = row.markupParam;
      this.dialogVisible = true;
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$modalSure("\u786E\u8BA4\u5220\u9664\u503A\u6743\u989D ".concat((row.debtRatio * 100).toFixed(0), "% \u6863\u4F4D\u5417\uFF1F")).then(function () {
        (0, _product.debtRatioDeleteApi)(row.id).then(function () {
          _this2.$message.success('删除成功');
          _this2.getList();
        }).catch(function (e) {
          _this2.$message.error(e.message || '删除失败');
        });
      }).catch(function () {});
    },
    handleToggle: function handleToggle(row) {
      var _this3 = this;
      (0, _product.debtRatioToggleApi)(row.id).then(function () {
        _this3.$message.success('操作成功');
      }).catch(function (e) {
        _this3.$message.error(e.message || '操作失败');
        row.isEnable = !row.isEnable;
      });
    },
    handleSubmit: function handleSubmit() {
      var _this4 = this;
      this.$refs.formRef.validate(function (valid) {
        if (!valid) return;
        _this4.submitLoading = true;
        var data = {
          debtRatio: _this4.form.debtRatioPercent / 100,
          markupParam: _this4.form.markupParam
        };
        var api = _this4.isEdit ? (0, _product.debtRatioUpdateApi)(_objectSpread(_objectSpread({}, data), {}, {
          id: _this4.editId
        })) : (0, _product.debtRatioAddApi)(data);
        api.then(function () {
          _this4.$message.success(_this4.isEdit ? '编辑成功' : '新增成功');
          _this4.dialogVisible = false;
          _this4.getList();
        }).catch(function (e) {
          _this4.$message.error(e.message || '操作失败');
        }).finally(function () {
          _this4.submitLoading = false;
        });
      });
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.$refs.formRef && this.$refs.formRef.resetFields();
    }
  }
};